export function equityRoute(ticker: string): string {
  return `/investments/${encodeURIComponent(ticker.trim().toUpperCase())}`;
}

export function etfRoute(ticker: string): string {
  return `/investments/etf/${encodeURIComponent(ticker.trim().toUpperCase())}`;
}

export const investmentsRoutes = {
  command: "/investments",
  coverage: "/investments/coverage",
  macro: "/investments/macro",
  portfolio: "/investments/portfolio",
  operator: "/investments/operator",
  glossary: "/investments/reference/glossary",
  method: "/investments/reference/method",
  help: "/investments/reference/help",
} as const;
